import { createFileRoute } from '@tanstack/react-router';

import { getTeamMemberQueryOption } from '@/_pages/team-members/api-service';
import Loading from '@/_pages/team-members/personal-details/loading';

export const Route = createFileRoute('/_private/team-members/_template/$id/personal-details')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getTeamMemberQueryOption(opts.params.id)),
  staticData: {
    pageTitle: 'Personal Details',
    tabKey: 'team-member/personal-details',
  },
  pendingComponent: Loading,
});
